import { useState, useEffect } from 'react';
import useAuthStore from '../store/authStore';
import { get } from '../helpers/apiHelper';

const useUserRole = () => {
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user, isAuthenticated } = useAuthStore();

  useEffect(() => {
    const fetchUserRole = async () => {
      if (!isAuthenticated || !user?.userId) {
        setUserRole(null);
        setLoading(false);
        return;
      }

      try {

        // Intentar obtener el rol desde el endpoint de perfil del usuario
        const userData = await get(`users/${user.userId}`);

        const role = userData?.role || userData?.userRole || null;
        setUserRole(role);

      } catch (error) {
        console.error('Error fetching user role:', error);
        setUserRole(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUserRole();
  }, [isAuthenticated, user?.userId]);

  return { userRole, loading };
};

export default useUserRole;
